/**
 * Vyelle PDP Sticky Bar
 * IntersectionObserver on #vy-buy-box: show bar when hero scrolls out of view.
 */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var bar    = document.getElementById('vy-sticky-bar');
    var buyBox = document.getElementById('vy-buy-box') || document.getElementById('buy-box');
    var cta    = document.getElementById('vy-sticky-cta');
    if (!bar || !buyBox) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = !entry.isIntersecting;
        bar.classList.toggle('visible', visible);
        bar.setAttribute('aria-hidden', String(!visible));
      });
    }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
    observer.observe(buyBox);
    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById('vy-buy-box') || document.getElementById('buy-box');
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(function () {
          target.classList.add('vy-buy-box-pulse');
          target.addEventListener('animationend', function () {
            target.classList.remove('vy-buy-box-pulse');
          }, { once: true });
        }, 350);
      });
    }
  });
})();
